import { createSlice } from "@reduxjs/toolkit";
import {
  fetchActiveSuppliers,
  fetchSupplierDetails,
  fetchSupplierProducts,
  searchSuppliers,
} from "../actions/supplierActions";

const initialState = {
  suppliers: {
    loading: false,
    error: null,
    data: [],
  },
  selectedSupplier: {
    loading: false,
    error: null,
    data: null,
  },
  supplierProducts: {
    loading: false,
    error: null,
    data: [],
  },
  searchResults: {
    loading: false,
    error: null,
    data: [],
    totalCount: 0,
    pageNumber: 1,
    pageSize: 100,
  },
};

const supplierSlice = createSlice({
  name: "suppliers",
  initialState,
  reducers: {
    clearSelectedSupplier: (state) => {
      state.selectedSupplier.data = null;
      state.selectedSupplier.error = null;
    },
    clearSupplierProducts: (state) => {
      state.supplierProducts.data = [];
      state.supplierProducts.error = null;
    },
    clearSearchResults: (state) => {
      state.searchResults.data = [];
      state.searchResults.error = null;
      state.searchResults.totalCount = 0;
    },
  },
  extraReducers: {
    // Get Active Suppliers
    [fetchActiveSuppliers.pending]: (state) => {
      state.suppliers.loading = true;
      state.suppliers.error = null;
    },
    [fetchActiveSuppliers.fulfilled]: (state, action) => {
      state.suppliers.loading = false;
      state.suppliers.data = action.payload.data || [];
    },
    [fetchActiveSuppliers.rejected]: (state, action) => {
      state.suppliers.loading = false;
      state.suppliers.error = action.payload;
    },

    // Get Supplier Details
    [fetchSupplierDetails.pending]: (state) => {
      state.selectedSupplier.loading = true;
      state.selectedSupplier.error = null;
    },
    [fetchSupplierDetails.fulfilled]: (state, action) => {
      state.selectedSupplier.loading = false;
      state.selectedSupplier.data = action.payload.data;
    },
    [fetchSupplierDetails.rejected]: (state, action) => {
      state.selectedSupplier.loading = false;
      state.selectedSupplier.error = action.payload;
    },

    // Search Suppliers
    [searchSuppliers.pending]: (state) => {
      state.searchResults.loading = true;
      state.searchResults.error = null;
    },
    [searchSuppliers.fulfilled]: (state, action) => {
      state.searchResults.loading = false;
      state.searchResults.data = action.payload.data?.items || [];
      state.searchResults.totalCount = action.payload.data?.totalCount || 0;
      state.searchResults.pageNumber = action.payload.data?.pageNumber || 1;
      state.searchResults.pageSize = action.payload.data?.pageSize || 10;
    },
    [searchSuppliers.rejected]: (state, action) => {
      state.searchResults.loading = false;
      state.searchResults.error = action.payload;
    },

    // Get Supplier Products
    [fetchSupplierProducts.pending]: (state) => {
      state.supplierProducts.loading = true;
      state.supplierProducts.error = null;
    },
    [fetchSupplierProducts.fulfilled]: (state, action) => {
      state.supplierProducts.loading = false;
      state.supplierProducts.data = action.payload.data || [];
    },
    [fetchSupplierProducts.rejected]: (state, action) => {
      state.supplierProducts.loading = false;
      state.supplierProducts.error = action.payload;
    },
  },
});

export const {
  clearSelectedSupplier,
  clearSupplierProducts,
  clearSearchResults,
} = supplierSlice.actions;

export default supplierSlice.reducer;
